import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { addFavorite, removeFavorite } from '../api';

// initialFavorited: pass true when rendering inside Favorites page
// addedByColleague: org accounts — show a subtle indicator if someone else favorited it

export default function FavoriteButton({ facilityId, initialFavorited = false, addedByColleague = null }) {
  const { hasFullAccess } = useAuth();
  const [favorited, setFavorited] = useState(initialFavorited);
  const [loading, setLoading]     = useState(false);

  if (!hasFullAccess) return null;

  const handleToggle = async (e) => {
    e.stopPropagation();
    if (loading) return;
    const next = !favorited;
    setFavorited(next); // optimistic
    setLoading(true);
    try {
      if (next) {
        await addFavorite(facilityId);
      } else {
        await removeFavorite(facilityId);
      }
    } catch {
      setFavorited(!next); // revert on error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      {/* Colleague indicator for org accounts */}
      {addedByColleague && !favorited && (
        <span className="text-xs text-gray-400" title={`${addedByColleague} added this`}>
          {addedByColleague.split(' ')[0]} ♥
        </span>
      )}

      <button
        onClick={handleToggle}
        disabled={loading}
        title={favorited ? 'Remove from favorites' : 'Add to favorites'}
        className={`transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-1 ${
          favorited
            ? 'text-red-500 hover:text-red-400'
            : 'text-gray-300 hover:text-red-400'
        }`}
      >
        <svg
          className={`w-5 h-5 transition-all ${loading ? 'opacity-40' : ''}`}
          viewBox="0 0 24 24"
          fill={favorited ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth={favorited ? 0 : 2}
        >
          <path strokeLinecap="round" strokeLinejoin="round"
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      </button>
    </div>
  );
}
